<template>
	<div class="cards">
		<div class="card-bodys">
			<div
				@click="isVisible = !isVisible"
				class="alert alert-secondary text-left col-md-12"
				style="cursor: pointer"
			>
				<h5 v-if="!isVisible">
					Click here to view already submitted annual report details
				</h5>
				<h5 v-if="isVisible">
					Click here to hide already submitted annual report details
				</h5>
			</div>
			<div v-if="isVisible" class="row">
				<div class="col-md-6">
					<div class="row mb-3">
						<label for="report_from" class="col-sm-4 col-form-label"
							>Report Period From:</label
						>
						<div class="col-sm-8">
							<input
								:value="report.period_from_formatted"
								name="report_from"
								id="report_from"
								type="text"
								class="form-control"
								disabled
							/>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="row mb-3">
						<label for="report_to" class="col-sm-4 col-form-label"
							>Report Period To:</label
						>
						<div class="col-sm-8">
							<input
								:value="report.period_to_formatted"
								name="report_to"
								id="report_to"
								type="text"
								class="form-control"
								disabled
							/>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="row mb-3">
						<label for="annual_report_type" class="col-sm-4 col-form-label"
							>Annual Report Type:</label
						>
						<div class="col-sm-8">
							<input
								:value="report.report_type"
								name="report_to"
								id="report_to"
								type="text"
								class="form-control"
								disabled
							/>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="row mb-3">
						<label for="cash_at_hand_start" class="col-sm-4 col-form-label"
							>Cash at hand at start of period:</label
						>
						<div class="col-sm-8">
							<input
								:value="report.cash_at_hand_start"
								name="cash_at_hand_start"
								id="cash_at_hand_start"
								type="text"
								class="form-control"
								placeholder="Eg. 5,000,000"
								disabled
							/>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="row mb-3">
						<label for="cash_at_hand_end" class="col-sm-4 col-form-label"
							>Cash at hand at close of reporting period:</label
						>
						<div class="col-sm-8">
							<input
								:value="report.cash_at_hand_end"
								name="cash_at_hand_end"
								id="cash_at_hand_end"
								type="text"
								class="form-control"
								placeholder="Eg. 5,000,000"
								disabled
							/>
						</div>
					</div>
				</div>

				<div class="col-md-6">
					<div class="row mb-3">
						<label for="approval_document" class="col-sm-4 col-form-label"
							>Upload Approval Document:<span class="text-danger"
								>*</span
							></label
						>
						<div class="col-sm-8">
							<a
								target="_blank"
								:href="report.approval_document"
								class="form-control"
								>View Document</a
							>
						</div>
					</div>
				</div>

				<div class="col-md-6">
					<div class="row mb-3">
						<label for="approved_by" class="col-sm-4 col-form-label"
							>Chairman Name:</label
						>
						<div class="col-sm-8">
							<input
								:value="report.approved_by"
								name="approved_by"
								id="approved_by"
								type="text"
								class="form-control"
								disabled
							/>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="row mb-3">
						<label for="prepared_by" class="col-sm-4 col-form-label"
							>Financial Secretary Name:<span class="text-danger"
								>*</span
							></label
						>
						<div class="col-sm-8">
							<input
								:value="report.prepared_by"
								name="prepared_by"
								id="prepared_by"
								type="text"
								class="form-control"
								disabled
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
	data() {
		return {
			isVisible: false,
		};
	},
	computed: {
		...mapGetters({
			report: "form_ec16c/singleForm",
		}),
	},
};
</script>
